import React from 'react'
import { useLocation, useNavigate } from "react-router-dom";
function Navbar() {

    const navigate = useNavigate();
    const location = useLocation();
    const moveToHome = (e) => {
        e.preventDefault();
        navigate("/dashboard");
    }
    const moveToStudent = (e) => {
        e.preventDefault();
        navigate("/student-registration");
    }
    const moveToList = (e) => {
        e.preventDefault();
        navigate("/student-list");
    }
    const moveToChallan = (e) => {
        e.preventDefault();
        navigate("/generate-challan");
    }
    const moveToChallanStatus = (e) => {
        e.preventDefault();
        navigate("/challan-status");
    }
    const moveToBoardSubmissionPending = (e) => {
        e.preventDefault();
        navigate("/board-submission-pending");
    }
    const moveToBoardApproved = (e) => {
        e.preventDefault();
        navigate("/board-submission-approved");
      }
     
    return (
        <nav class="pc-sidebar">
            <div class="navbar-wrapper">
                <div class="m-header">
                    <a href="" onClick={moveToHome} class="b-brand text-primary mbose-section">
                        <img src="../assets/images/MBOSE.png" class="logo-md" alt="logo" height={50} />
                        <h3 className='mbose-text'>MBOSE</h3>
                    </a>
                </div>
                <div class="navbar-content">
                    <ul class="pc-navbar">
                        <li className={`pc-item ${location.pathname === "/dashboard" ? "active" : ""}`}>
                            <a href="" onClick={moveToHome} className="pc-link">
                                <span className="pc-micon"><i className="ti ti-dashboard"></i></span>
                                <span className="pc-mtext">Dashboard</span>
                            </a>
                        </li>

                        <li class="pc-item pc-caption">
                            <label>Pages</label>
                            <i class="ti ti-dashboard"></i>
                        </li>
                        <li className={`pc-item ${location.pathname === "/student-registration" ? "active" : ""}`}>
                            <a href="" onClick={moveToStudent} className="pc-link">
                                <span class="pc-micon"><i className="fas fa-file-alt"></i></span>
                                <span class="pc-mtext">Eligible Candidates</span>
                            </a>
                        </li>
                        <li className={`pc-item ${location.pathname === "/student-list" ? "active" : ""}`}>
                            <a href="" onClick={moveToList} className="pc-link">
                                <span class="pc-micon"><i class="fa fa-user"></i></span>
                                <span class="pc-mtext">Total Registrations Done</span>
                            </a>
                        </li>
                        <li className={`pc-item ${location.pathname === "/generate-challan" ? "active" : ""}`}>
                            <a href="" onClick={moveToChallan} className="pc-link">
                                <span class="pc-micon"><i class="fa fa-list"></i></span>
                                <span class="pc-mtext">Challan Generation Pending</span>
                            </a>
                        </li>
                        <li className={`pc-item ${location.pathname === "/challan-status" ? "active" : ""}`}>
                            <a href="" onClick={moveToChallanStatus} className="pc-link">
                                <span class="pc-micon"><i class="fa fa-bars-progress"></i></span>
                                <span class="pc-mtext">Challan Generated</span>
                            </a>
                        </li>
                        <li className={`pc-item ${location.pathname === "/board-submission-pending" ? "active" : ""}`}>
                            <a href="" onClick={moveToBoardSubmissionPending} className="pc-link">
                                <span class="pc-micon"><i class="fa fa-clock"></i></span>
                                <span class="pc-mtext">Board Submission Pending</span>
                            </a>
                        </li>
                        <li className={`pc-item ${location.pathname === "/board-submission-approved" ? "active" : ""}`}>
                            <a href="" className="pc-link" onClick={moveToBoardApproved}>
                                <span class="pc-micon"><i class="fa fa-check"></i></span>
                                <span class="pc-mtext">Approved by Board</span>
                            </a>
                        </li>
                      
                        {/* <li class="pc-item">
                    <a href="../elements/bc_color.html" class="pc-link">
                        <span class="pc-micon"><i class="ti ti-color-swatch"></i></span>
                        <span class="pc-mtext">Color</span>
                    </a>
                </li>
                <li class="pc-item">
                    <a href="../elements/icon-tabler.html" class="pc-link">
                        <span class="pc-micon"><i class="ti ti-plant-2"></i></span>
                        <span class="pc-mtext">Icons</span>
                    </a>
                </li>

                <li class="pc-item pc-caption">
                    <label>Pages</label>
                    <i class="ti ti-news"></i>
                </li>
                <li class="pc-item">
                    <a href="../pages/login.html" class="pc-link">
                        <span class="pc-micon"><i class="ti ti-lock"></i></span>
                        <span class="pc-mtext">Login</span>
                    </a>
                </li>
                <li class="pc-item">
                    <a href="../pages/register.html" class="pc-link">
                        <span class="pc-micon"><i class="ti ti-user-plus"></i></span>
                        <span class="pc-mtext">Register</span>
                    </a>
                </li>

                <li class="pc-item pc-caption">
                    <label>Other</label>
                    <i class="ti ti-brand-chrome"></i>
                </li>
                <li class="pc-item pc-hasmenu">
                    <a href="#!" class="pc-link"><span class="pc-micon"><i class="ti ti-menu"></i></span><span class="pc-mtext">Menu
                        levels</span><span class="pc-arrow"><i data-feather="chevron-right"></i></span></a>
                    <ul class="pc-submenu">
                        <li class="pc-item"><a class="pc-link" href="#!">Level 2.1</a></li>
                        <li class="pc-item pc-hasmenu">
                            <a href="#!" class="pc-link">Level 2.2<span class="pc-arrow"><i data-feather="chevron-right"></i></span></a>
                            <ul class="pc-submenu">
                                <li class="pc-item"><a class="pc-link" href="#!">Level 3.1</a></li>
                                <li class="pc-item"><a class="pc-link" href="#!">Level 3.2</a></li>
                                <li class="pc-item pc-hasmenu">
                                    <a href="#!" class="pc-link">Level 3.3<span class="pc-arrow"><i data-feather="chevron-right"></i></span></a>
                                    <ul class="pc-submenu">
                                        <li class="pc-item"><a class="pc-link" href="#!">Level 4.1</a></li>
                                        <li class="pc-item"><a class="pc-link" href="#!">Level 4.2</a></li>
                                    </ul>
                                </li>
                            </ul>
                        </li>
                        <li class="pc-item pc-hasmenu">
                            <a href="#!" class="pc-link">Level 2.3<span class="pc-arrow"><i data-feather="chevron-right"></i></span></a>
                            <ul class="pc-submenu">
                                <li class="pc-item"><a class="pc-link" href="#!">Level 3.1</a></li>
                                <li class="pc-item"><a class="pc-link" href="#!">Level 3.2</a></li>
                                <li class="pc-item pc-hasmenu">
                                    <a href="#!" class="pc-link">Level 3.3<span class="pc-arrow"><i data-feather="chevron-right"></i></span></a>
                                    <ul class="pc-submenu">
                                        <li class="pc-item"><a class="pc-link" href="#!">Level 4.1</a></li>
                                        <li class="pc-item"><a class="pc-link" href="#!">Level 4.2</a></li>
                                    </ul>
                                </li>
                            </ul>
                        </li>
                    </ul>
                </li>
                <li class="pc-item">
                    <a href="../other/sample-page.html" class="pc-link">
                        <span class="pc-micon"><i class="ti ti-brand-chrome"></i></span>
                        <span class="pc-mtext">Sample page</span>
                    </a>
                </li> */}
                    </ul>


                </div>
            </div>
        </nav>
    )
}

export default Navbar